import OverlayRenderer from './overlay-renderer';
import TextRenderer from './text-renderer';
import MaskRenderer from './mask-renderer';
import ProductRenderer from './product-renderer';
import UploadRenderer from './upload-renderer';
import QrcodeRenderer from './qrcode-renderer';
import AreaRenderer from './area-renderer';

class RendererRegistry {
}

RendererRegistry.renderers = {};

// register renderers
RendererRegistry.renderers['overlay'] = new OverlayRenderer();
RendererRegistry.renderers['text'] = new TextRenderer();
RendererRegistry.renderers['mask'] = new MaskRenderer();
RendererRegistry.renderers['product'] = new ProductRenderer();
RendererRegistry.renderers['upload'] = new UploadRenderer();
RendererRegistry.renderers['qrcode'] = new QrcodeRenderer();
RendererRegistry.renderers['area'] = new AreaRenderer();

export default RendererRegistry;
